<mat-sidenav-container class="layout">
    <mat-sidenav
      #drawer
      class="sidenav"
      mode="over"
      [opened]="false"
    >
      <div class="brand" routerLink="/accueil" (click)="closeIfHandset(isHandset)" tabindex="0">
        <div class="brand__logo">S</div>
        <div class="brand__text">
          <div class="brand__name">Saarvie</div>
          <div class="brand__tagline">Assurances en ligne</div>
        </div>
      </div>

      <mat-nav-list>
        <a mat-list-item routerLink="/accueil" routerLinkActive="active" (click)="closeIfHandset(isHandset)">
          <mat-icon matListItemIcon>home</mat-icon>
          <span matListItemTitle>Accueil</span>
        </a>

        <a mat-list-item routerLink="/profil" routerLinkActive="active" (click)="closeIfHandset(isHandset)">
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>Profil</span>
        </a>

        <a mat-list-item routerLink="/accueil" fragment="agences" routerLinkActive="active" (click)="closeIfHandset(isHandset)">
          <mat-icon matListItemIcon>location_city</mat-icon>
          <span matListItemTitle>Agences</span>
        </a>

        <a mat-list-item routerLink="/nous-contacter" routerLinkActive="active" (click)="closeIfHandset(isHandset)">
          <mat-icon matListItemIcon>support_agent</mat-icon>
          <span matListItemTitle>Nous contacter</span>
        </a>

        <mat-divider></mat-divider>

        <a mat-list-item routerLink="/se-connecter" routerLinkActive="active" (click)="closeIfHandset(isHandset)">
          <mat-icon matListItemIcon>login</mat-icon>
          <span matListItemTitle>Se connecter</span>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="topbar">
        <div class="topbar__inner">
          <span>Bienvenue chez Saarvie, votre assureur de confiance.</span>
          <span>+225 07 00 00 00 00</span>
          <span>Lun - Ven: 08:00 - 17:00</span>
        </div>
      </div>
      <mat-toolbar color="primary" class="toolbar">
        <button mat-icon-button type="button" (click)="drawer.toggle()" aria-label="Ouvrir le menu">
          <mat-icon>menu</mat-icon>
        </button>
        <span class="toolbar__title">Saarvie Web</span>
        <span class="toolbar__spacer"></span>
        <a mat-button routerLink="/se-connecter">
          <mat-icon>lock</mat-icon>
          <span>Connexion</span>
        </a>
      </mat-toolbar>

      <main class="content">
        <router-outlet></router-outlet>

        <footer class="footer">
          <div class="footer__grid">
            <div>
              <div class="footer__title">Saarvie</div>
              <div class="footer__text">Une expérience simple et rapide pour souscrire, payer et déclarer un sinistre en ligne.</div>
            </div>
            <div>
              <div class="footer__title">Support</div>
              <a class="footer__link" routerLink="/nous-contacter">Nous contacter</a>
              <a class="footer__link" routerLink="/accueil" fragment="agences">Voir nos agences</a>
            </div>
            <div>
              <div class="footer__title">Espace</div>
              <a class="footer__link" routerLink="/se-connecter">Se connecter</a>
              <a class="footer__link" routerLink="/profil">Profil</a>
            </div>
          </div>
          <div class="footer__bottom">© {{ year }} Saarvie. Tous droits réservés.</div>
        </footer>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
